(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mm-shipping-promo"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', (event) => {
  const link = event.target.closest('[data-mm-shop-menu]');
  if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  const header = document.querySelector('[data-header-section]');
  if (!header) return;
  const menuButton = header.querySelector('[data-menu-button]');
  const drawer = header.querySelector('[data-component="navigation-drawer"]');
  const shop = drawer && Array.from(drawer.querySelectorAll('.nav-drawer__tier-1-link[data-nav-drawer-summary]')).find(item => item.textContent.trim().toLowerCase() === 'shop');
  if (menuButton && menuButton.getClientRects().length && shop) {
    event.preventDefault();
    event.stopPropagation();
    drawer.addEventListener('focusin', () => {
      requestAnimationFrame(() => {
        if (!shop.parentElement.open) shop.click();
      });
    }, { once: true });
    menuButton.click();
    return;
  }
  const desktopShop = Array.from(header.querySelectorAll('[data-nav-desktop-details] > summary')).find(item => item.textContent.trim().toLowerCase() === 'shop');
  if (desktopShop) {
    event.preventDefault();
    event.stopPropagation();
    window.scrollTo({ top: 0, behavior: 'smooth' });
    if (!desktopShop.parentElement.open) desktopShop.click();
    desktopShop.focus();
  }
});

  } catch(e) { console.error(e); }
})();
})();
